module.exports = __webpack_public_path__ + "img/facebook.f3eb48b0.svg";